import React from 'react';
import { Flex, TextV2 } from '@withjoy/joykit';
import { pxToRem } from '@withjoy/joykit/theme';
import { GuestSiteTypographyOverride } from '@apps/guest/components/GuestSiteTypographyOverride/GuestSiteTypographyOverride';
import type { OverrideTypography } from '@apps/guest/components/GuestSiteTypographyOverride/GuestSiteTypographyOverride.types';
import { Category } from '@graphql/generated-base';
import { useScaleGuestSiteFontSize } from '@shared/core/website/theming/useScaleGuestSiteFontSize';
import { useTranslation } from '@shared/core';

type CustomComponentEmptyStateProps = Readonly<{
  isBrannanLayout?: boolean;
}>;

const typographyOverride: OverrideTypography = [
  { variant: 'hed1', category: Category.HEADING },
  { variant: 'body2', category: Category.PARAGRAPH },
];

export const CustomComponentEmptyState: React.FC<CustomComponentEmptyStateProps> = ({ isBrannanLayout }) => {
  const { scaleFontSize } = useScaleGuestSiteFontSize();
  const { tq } = useTranslation('guestSiteCustom');

  return (
    <Flex
      flexDirection="column"
      alignItems="center"
      paddingX={6}
      paddingTop={pxToRem(44)}
      paddingBottom={isBrannanLayout ? 0 : pxToRem(44)}
      marginTop={isBrannanLayout ? 0 : 8}
    >
      <Flex
        flexDirection="column"
        alignItems="center"
        paddingY={pxToRem(44)}
        rowGap={pxToRem(44)}
        maxWidth={pxToRem(482)}
        marginX="auto"
      >
        <GuestSiteTypographyOverride override={typographyOverride}>
          <Flex
            flexDirection="column"
            rowGap={3}
            width="100%"
          >
            <TextV2
              typographyVariant="hed1"
              fontSize={scaleFontSize(pxToRem(26), Category.HEADING)}
              fontWeight={600}
              textAlign="center"
            >
              {tq`Coming Soon`}
            </TextV2>
            <TextV2
              typographyVariant="body2"
              maxWidth={pxToRem(314)}
              lineHeight={pxToRem(24)}
              textAlign="center"
            >
              {tq`Check back closer to the event.`}
            </TextV2>
          </Flex>
        </GuestSiteTypographyOverride>
      </Flex>
    </Flex>
  );
};
